// @ts-nocheck
/* eslint-disable */

  /**
  * Do not change! File was auto generate. 
  *
  */
  
import React from 'react';

import { ReactComponent as ArrowLeftComponent} from './ArrowLeft.svg';

import Icon, { TIconProps } from '../Icon';

export const IconArrowLeft = React.forwardRef<any, TIconProps>((props, ref) => (
  <Icon
    ref={ref}
    {...props}
  >
    <ArrowLeftComponent/>
  </Icon>
));
